import {Component} from "@angular/core";
import {ReplicaSet} from "../../../model/replicaset.model";
import {ReplicaSetService} from "../../../service/replicaset.service";
import {ReplicationController} from "../../../model/replicationcontroller.model";
import {ReplicationControllerService} from "../../../service/replicationcontroller.service";
import {CompositeReplicaSetStore} from "../../../store/compositedreplicaset.store";

@Component({
  selector: 'delete-replicaset-dialog',
  templateUrl: './delete-dialog.replicaset.component.html',
  styleUrls: ['./delete-dialog.replicaset.component.scss'],
})
export class ReplicaSetDeleteDialog {
  replicaset: ReplicaSet = new ReplicaSet();
  modal: any;

  constructor(private replicasetService: ReplicaSetService,
              private replicationControllerService: ReplicationControllerService,
              private replicasetStore: CompositeReplicaSetStore) {
  }

  ok() {
    const replicaset = this.replicaset;
    console.log('deleting replicaset ' + replicaset.name);
    this.modal.close();
    if (replicaset instanceof ReplicationController) {
      this.replicationControllerService.delete(replicaset).subscribe(
        () => {
          this.replicasetStore.loadAll();
        },
      );
    } else {
      this.replicasetService.delete(replicaset).subscribe(
        () => {
          this.replicasetStore.loadAll();
        },
      );
    }
  }

  close() {
    this.modal.close();
  }
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
